var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEyeSlash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5 18C13.2475 18 14.9402 17.6523 16.498 17M11.5 18C9.75249 18 8.05979 17.6523 6.50197 17M11.5 18V21M1.15137 12.5C1.2712 12.8816 1.46219 13.2377 1.72432 13.5384C2.26684 14.1627 2.86165 14.7288 3.5 15.232M21.8486 12.5C21.7288 12.8816 21.5378 13.2377 21.2757 13.5384C20.7332 14.1627 20.1383 14.7288 19.5 15.232M3.5 15.232L1.5 18M3.5 15.232C4.41915 15.9565 5.42854 16.5505 6.50197 17M19.5 15.232L21.5 18M19.5 15.232C18.5808 15.9565 17.5715 16.5505 16.498 17M16.498 17L17.5 20M6.50197 17L5 20",
    stroke: "#7A7A7A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEyeSlash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-eye-slash.932f3fee2b8b94ae6b5d1f64e5ceae9a.svg";